/**
 * Apollo Ski Theme – product gallery, AJAX add to cart, sticky bar, cart drawer
 */
document.addEventListener('DOMContentLoaded', function () {
  // ----- Cart count (for header, updated after AJAX add to cart) -----
  function updateCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        el.textContent = cart.item_count || 0;
      })
      .catch(function () {});
  }

  // ----- Money formatting (Shopify-style) -----
  var MONEY_FORMAT = (window.ApolloProduct && window.ApolloProduct.moneyFormat) || '${{amount}}';
  function formatMoney(cents, format) {
    var formatString = format || MONEY_FORMAT;
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  // ----- Product page gallery (media slides: images + video, thumbs, arrows, lightbox) -----
  var galleryMain = document.querySelector('[data-product-gallery-main]');
  var slides = galleryMain ? Array.prototype.slice.call(galleryMain.querySelectorAll('[data-gallery-slide]')) : [];
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
  var currentIndex = 0;

  function pauseSlideVideos() {
    slides.forEach(function (slide) {
      var v = slide.querySelector('video');
      if (v && !v.paused) { try { v.pause(); } catch (e) {} }
    });
  }

  function playActiveVideo() {
    var slide = slides[currentIndex];
    if (!slide) return;
    var v = slide.querySelector('video');
    if (v) {
      v.muted = true;
      v.loop = true;
      v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function setGalleryIndex(index) {
    if (!slides.length) return;
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === currentIndex); });
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === currentIndex); });
    pauseSlideVideos();
    playActiveVideo();
    updateLightboxImage();
  }

  function setGalleryByMediaId(id) {
    if (id == null) return;
    var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); });
    if (idx !== -1) setGalleryIndex(idx);
  }

  if (galleryMain && slides.length) {
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setGalleryIndex(i); });
    });
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { setGalleryIndex(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setGalleryIndex(currentIndex + 1); });
    playActiveVideo();
  }

  // ----- Image lightbox / zoom (image slides only) -----
  var lightbox = document.querySelector('[data-product-lightbox]');
  var lightboxImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
  var imageIndices = slides.reduce(function (acc, s, i) {
    if (s.getAttribute('data-media-type') === 'image') acc.push(i);
    return acc;
  }, []);

  function updateLightboxImage() {
    if (!lightbox || !lightboxImg) return;
    var slide = slides[currentIndex];
    if (slide && slide.getAttribute('data-media-type') === 'image') {
      var img = slide.querySelector('img');
      lightboxImg.src = slide.getAttribute('data-zoom') || (img ? img.src : '');
      lightboxImg.alt = img ? img.alt : '';
    }
  }

  if (lightbox && lightboxImg && imageIndices.length) {
    var zoomTriggers = document.querySelectorAll('[data-gallery-zoom]');
    function openLightbox() {
      var slide = slides[currentIndex];
      if (!slide || slide.getAttribute('data-media-type') !== 'image') return;
      updateLightboxImage();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
    }
    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
    }
    function lightboxStep(dir) {
      var pos = imageIndices.indexOf(currentIndex);
      if (pos === -1) pos = 0;
      pos = (pos + dir + imageIndices.length) % imageIndices.length;
      setGalleryIndex(imageIndices[pos]);
    }
    zoomTriggers.forEach(function (t) {
      t.addEventListener('click', openLightbox);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(); }
      });
    });
    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (btn) {
      btn.addEventListener('click', closeLightbox);
    });
    var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    var lbNext = lightbox.querySelector('[data-lightbox-next]');
    if (lbPrev) lbPrev.addEventListener('click', function () { lightboxStep(-1); });
    if (lbNext) lbNext.addEventListener('click', function () { lightboxStep(1); });
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') lightboxStep(-1);
      else if (e.key === 'ArrowRight') lightboxStep(1);
    });
  }

  // ----- Variant selection + quantity -----
  var variants = (window.ApolloProduct && window.ApolloProduct.variants) || [];
  var optionInputs = document.querySelectorAll('[data-product-option-input]');
  var variantIdInputs = document.querySelectorAll('[data-variant-id]');
  var priceEl = document.querySelector('[data-product-price]');
  var compareEl = document.querySelector('[data-product-compare]');
  var saveEl = document.querySelector('[data-product-save]');
  var stickyPriceEl = document.querySelector('[data-sticky-price]');
  var addButtons = document.querySelectorAll('[data-add-to-cart]');
  var inventoryEl = document.querySelector('[data-product-inventory]');
  var lowStockThreshold = inventoryEl ? (parseInt(inventoryEl.getAttribute('data-low-stock-threshold'), 10) || 10) : 10;
  function getSelectedOptions() {
    var selected = [];
    optionInputs.forEach(function (input) {
      if (input.checked) {
        var pos = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        selected[pos] = input.value;
      }
    });
    return selected;
  }

  function findVariant(selected) {
    return variants.find(function (v) {
      return v.options.length === selected.length && v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function updateBuyButtons(variant) {
    addButtons.forEach(function (btn) {
      if (!variant) { btn.disabled = true; btn.textContent = 'Unavailable'; }
      else if (!variant.available) { btn.disabled = true; btn.textContent = 'Sold out'; }
      else { btn.disabled = false; btn.textContent = 'Add to cart'; }
    });
  }

  function updatePriceDisplay(variant) {
    if (!variant) return;
    if (priceEl) {
      priceEl.textContent = variant.price;
      priceEl.classList.toggle('main-product__price--sale', !!variant.compareAtPrice);
    }
    if (stickyPriceEl) stickyPriceEl.textContent = variant.price;
    if (compareEl) {
      if (variant.compareAtPrice) { compareEl.textContent = variant.compareAtPrice; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    if (saveEl) {
      if (variant.save) { saveEl.textContent = 'Save ' + variant.save; saveEl.hidden = false; }
      else { saveEl.hidden = true; }
    }
  }

  function updateInventory(variant) {
    if (!inventoryEl) return;
    if (variant && variant.available && variant.inventoryManagement === 'shopify' &&
        typeof variant.inventoryQuantity === 'number' && variant.inventoryQuantity > 0 &&
        variant.inventoryQuantity <= lowStockThreshold) {
      inventoryEl.textContent = 'Only ' + variant.inventoryQuantity + ' left in stock';
      inventoryEl.hidden = false;
    } else {
      inventoryEl.hidden = true;
    }
  }

  function updateSelectedLabels() {
    optionInputs.forEach(function (input) {
      if (input.checked) {
        var pos = input.getAttribute('data-option-position');
        var label = document.querySelector('[data-option-selected="' + pos + '"]');
        if (label) label.textContent = input.value;
        var group = input.closest('.variant-option__values');
        if (group) {
          group.querySelectorAll('.variant-swatch').forEach(function (sw) { sw.classList.remove('is-active'); });
        }
        var swatch = input.closest('.variant-swatch');
        if (swatch) swatch.classList.add('is-active');
      }
    });
  }

  function onVariantChange() {
    var selected = getSelectedOptions();
    var variant = findVariant(selected);
    updateSelectedLabels();
    if (variant) {
      variantIdInputs.forEach(function (input) { input.value = variant.id; });
      updatePriceDisplay(variant);
      updateInventory(variant);
      if (variant.featuredMediaId != null) setGalleryByMediaId(variant.featuredMediaId);
    } else {
      updateInventory(null);
    }
    updateBuyButtons(variant);
  }

  if (optionInputs.length && variants.length) {
    optionInputs.forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });
    onVariantChange();
  } else if (variants.length === 1) {
    updateInventory(variants[0]);
  }

  // Quantity selector (+/- buttons)
  document.querySelectorAll('[data-qty-selector]').forEach(function (selector) {
    var input = selector.querySelector('[data-qty-input]');
    var minus = selector.querySelector('[data-qty-minus]');
    var plus = selector.querySelector('[data-qty-plus]');
    if (!input) return;
    function clamp() {
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      input.value = val;
    }
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
    input.addEventListener('change', clamp);
  });

  // ----- Brand photos: arrow buttons scroll the strip on desktop -----
  var brandPhotosScroll = document.querySelector('[data-brand-photos-scroll]');
  var brandPhotosPrev = document.querySelector('[data-brand-photos-prev]');
  var brandPhotosNext = document.querySelector('[data-brand-photos-next]');
  if (brandPhotosScroll && brandPhotosPrev && brandPhotosNext) {
    var scrollAmount = 300;
    function updateBrandPhotosArrows() {
      var el = brandPhotosScroll;
      brandPhotosPrev.disabled = el.scrollLeft <= 0;
      brandPhotosNext.disabled = el.scrollLeft >= el.scrollWidth - el.clientWidth - 2;
    }
    brandPhotosPrev.addEventListener('click', function () {
      brandPhotosScroll.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    brandPhotosNext.addEventListener('click', function () {
      brandPhotosScroll.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
    brandPhotosScroll.addEventListener('scroll', updateBrandPhotosArrows);
    updateBrandPhotosArrows();
  }

  // ----- Features: arrow buttons scroll the strip on mobile (matches brand photos) -----
  var featuresScroll = document.querySelector('[data-features-scroll]');
  var featuresPrev = document.querySelector('[data-features-prev]');
  var featuresNext = document.querySelector('[data-features-next]');
  if (featuresScroll && featuresPrev && featuresNext) {
    var featuresScrollAmount = 300;
    function updateFeaturesArrows() {
      var el = featuresScroll;
      featuresPrev.disabled = el.scrollLeft <= 0;
      featuresNext.disabled = el.scrollLeft >= el.scrollWidth - el.clientWidth - 2;
    }
    featuresPrev.addEventListener('click', function () {
      featuresScroll.scrollBy({ left: -featuresScrollAmount, behavior: 'smooth' });
    });
    featuresNext.addEventListener('click', function () {
      featuresScroll.scrollBy({ left: featuresScrollAmount, behavior: 'smooth' });
    });
    featuresScroll.addEventListener('scroll', updateFeaturesArrows);
    updateFeaturesArrows();
  }

  // ----- Featured collection carousel (desktop + mobile fallback) -----
  function initFeaturedCollectionCarousel(scrollEl, prevBtn, nextBtn) {
    if (!scrollEl || !prevBtn || !nextBtn) return;
    var slides = scrollEl.querySelectorAll('.product-grid__item');
    function getSlideWidth() {
      if (!slides.length) return 300;
      var slide = slides[0];
      var list = slide.parentElement;
      var gap = list && window.getComputedStyle ? parseFloat(window.getComputedStyle(list).gap) || 0 : 0;
      return slide.offsetWidth + gap;
    }
    function updateArrows() {
      prevBtn.disabled = scrollEl.scrollLeft <= 0;
      nextBtn.disabled = scrollEl.scrollLeft >= scrollEl.scrollWidth - scrollEl.clientWidth - 2;
    }
    prevBtn.addEventListener('click', function () {
      scrollEl.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      scrollEl.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
    });
    scrollEl.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  document.querySelectorAll('.featured-collection__carousel-wrap').forEach(function (wrap) {
    initFeaturedCollectionCarousel(
      wrap.querySelector('[data-featured-collection-scroll], [data-featured-collection-scroll-mobile]'),
      wrap.querySelector('[data-featured-collection-prev], [data-featured-collection-prev-mobile]'),
      wrap.querySelector('[data-featured-collection-next], [data-featured-collection-next-mobile]')
    );
  });

  document.querySelectorAll('.product-recommendations__carousel-wrap').forEach(function (wrap) {
    initFeaturedCollectionCarousel(
      wrap.querySelector('[data-product-recommendations-scroll]'),
      wrap.querySelector('[data-product-recommendations-prev]'),
      wrap.querySelector('[data-product-recommendations-next]')
    );
  });

  // ----- Product recommendations: fetch Shopify related products when available -----
  document.querySelectorAll('product-recommendations[data-url]').forEach(function (el) {
    if (!el.dataset.url || el.dataset.loaded === 'true') return;
    fetch(el.dataset.url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetched = doc.querySelector('product-recommendations');
        if (!fetched) return;
        var fetchedTrack = fetched.querySelector('.product-recommendations__track');
        var currentTrack = el.querySelector('.product-recommendations__track');
        if (fetchedTrack && fetchedTrack.children.length && currentTrack) {
          currentTrack.innerHTML = fetchedTrack.innerHTML;
          el.dataset.loaded = 'true';
          var wrap = el.querySelector('.product-recommendations__carousel-wrap');
          if (wrap) {
            initFeaturedCollectionCarousel(
              wrap.querySelector('[data-product-recommendations-scroll]'),
              wrap.querySelector('[data-product-recommendations-prev]'),
              wrap.querySelector('[data-product-recommendations-next]')
            );
          }
        }
      })
      .catch(function () {});
  });

  // ----- Reviews: prev/next scroll to exact card by index, nav below, no scrollbar -----
  var reviewsScroll = document.querySelector('[data-reviews-scroll]');
  var reviewsPrev = document.querySelector('[data-reviews-prev]');
  var reviewsNext = document.querySelector('[data-reviews-next]');
  if (reviewsScroll && reviewsPrev && reviewsNext) {
    var reviewsList = reviewsScroll.querySelector('.reviews__list');
    var reviewsCards = reviewsScroll ? reviewsScroll.querySelectorAll('.reviews__card') : [];
    function getCurrentCardIndex() {
      if (!reviewsCards.length) return 0;
      var scrollLeft = reviewsScroll.scrollLeft;
      var listPadding = reviewsList && window.getComputedStyle ? parseInt(window.getComputedStyle(reviewsList).paddingLeft, 10) || 0 : 0;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < reviewsCards.length; i++) {
        var cardLeft = reviewsCards[i].offsetLeft - listPadding;
        var dist = Math.abs(cardLeft - scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }
    function scrollToCard(index) {
      if (index < 0 || index >= reviewsCards.length) return;
      var targetLeft = reviewsCards[index].offsetLeft;
      reviewsScroll.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }
    function updateReviewsArrows() {
      var idx = getCurrentCardIndex();
      reviewsPrev.disabled = idx <= 0;
      reviewsNext.disabled = idx >= reviewsCards.length - 1;
    }
    reviewsPrev.addEventListener('click', function () {
      var idx = getCurrentCardIndex();
      if (idx > 0) scrollToCard(idx - 1);
    });
    reviewsNext.addEventListener('click', function () {
      var idx = getCurrentCardIndex();
      if (idx < reviewsCards.length - 1) scrollToCard(idx + 1);
    });
    reviewsScroll.addEventListener('scroll', updateReviewsArrows);
    window.addEventListener('resize', updateReviewsArrows);
    updateReviewsArrows();
  }

  // Sticky bar: show when main add-to-cart scrolls out of view
  var stickyBar = document.querySelector('[data-product-sticky-bar]');
  var mainAdd = document.querySelector('.main-product__add');
  if (stickyBar && mainAdd) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      },
      { rootMargin: '-80px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(mainAdd);
  }

  // AJAX add to cart (main form + sticky form) and open drawer
  var drawer = document.getElementById('cart-drawer');
  var drawerClose = document.querySelectorAll('[data-cart-drawer-close]');
  function openDrawer() {
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
    }
    updateCartCount();
  }
  function fillCartDrawer(item) {
    if (!drawer) return;
    var itemWrap = drawer.querySelector('[data-cart-drawer-item]');
    if (itemWrap && item) {
      var img = itemWrap.querySelector('[data-cart-drawer-image]');
      if (img) {
        if (item.image) { img.src = item.image; img.hidden = false; }
        else { img.hidden = true; }
      }
      var titleEl = itemWrap.querySelector('[data-cart-drawer-item-title]');
      if (titleEl) titleEl.textContent = item.product_title || item.title || '';
      var variantEl = itemWrap.querySelector('[data-cart-drawer-item-variant]');
      if (variantEl) {
        var vt = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        variantEl.textContent = vt;
        variantEl.hidden = !vt;
      }
      var metaEl = itemWrap.querySelector('[data-cart-drawer-item-meta]');
      if (metaEl) {
        var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
        metaEl.textContent = 'Qty ' + item.quantity + ' · ' + formatMoney(linePrice);
      }
      itemWrap.hidden = false;
    }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = drawer.querySelector('[data-cart-drawer-count]');
        if (countEl) countEl.textContent = cart.item_count;
        var pluralEl = drawer.querySelector('[data-cart-drawer-count-plural]');
        if (pluralEl) pluralEl.textContent = cart.item_count === 1 ? '' : 's';
        var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
        if (subtotalEl) {
          var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
          subtotalEl.textContent = formatMoney(sub);
        }
      })
      .catch(function () {});
  }
  function closeDrawer() {
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }
  }
  drawerClose.forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  if (drawer && drawer.querySelector('.cart-drawer__backdrop')) {
    drawer.querySelector('.cart-drawer__backdrop').addEventListener('click', closeDrawer);
  }
  if (drawer) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  var addForms = document.querySelectorAll('form[data-product-form], form[data-product-form-sticky]');
  addForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('button[name="add"]');
      if (submitBtn && submitBtn.disabled) return;
      var formData = new FormData(form);
      var body = new URLSearchParams(formData);
      if (!body.get('quantity')) body.set('quantity', '1');
      submitBtn && (submitBtn.disabled = true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: body.toString()
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.message && !data.id) {
            if (typeof window.alert === 'function') window.alert(data.message);
          } else {
            fillCartDrawer(data);
            openDrawer();
          }
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          submitBtn && (submitBtn.disabled = false);
        });
    });
  });

  // Cart page form
  var cartForm = document.querySelector('.main-cart__form');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name === 'checkout') return;
    });
  }

  // ----- Mailchimp JSONP subscribe (email popup + footer) -----
  function subscribeViaMailchimp(mailchimpAction, email, callbacks) {
    callbacks = callbacks || {};
    if (!mailchimpAction || mailchimpAction.indexOf('list-manage.com/subscribe/post') === -1) {
      if (callbacks.onError) {
        callbacks.onError('Please add your Mailchimp form URL in the theme editor.');
      }
      return;
    }
    var callbackName = '__mcApollo_' + Date.now();
    var scriptEl = null;
    var timeoutId = setTimeout(function () {
      if (scriptEl && scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
      window[callbackName] = null;
      if (callbacks.onError) callbacks.onError('Something went wrong. Please try again.');
    }, 15000);
    window[callbackName] = function (data) {
      clearTimeout(timeoutId);
      if (scriptEl && scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
      window[callbackName] = null;
      if (data && data.result === 'success') {
        if (callbacks.onSuccess) callbacks.onSuccess(data);
      } else if (callbacks.onError) {
        callbacks.onError((data && data.msg) ? data.msg : 'Something went wrong. Please try again.');
      }
    };
    var jsonpUrl = mailchimpAction.replace('/subscribe/post?', '/subscribe/post-json?');
    jsonpUrl += (jsonpUrl.indexOf('?') !== -1 ? '&' : '?') + 'EMAIL=' + encodeURIComponent(email) + '&c=' + encodeURIComponent(callbackName);
    scriptEl = document.createElement('script');
    scriptEl.src = jsonpUrl;
    scriptEl.async = true;
    scriptEl.onerror = function () {
      clearTimeout(timeoutId);
      if (scriptEl && scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
      window[callbackName] = null;
      if (callbacks.onError) callbacks.onError('Something went wrong. Please try again.');
    };
    document.body.appendChild(scriptEl);
  }

  // ----- Footer email signup -----
  var footerNewsletter = document.querySelector('[data-footer-newsletter]');
  if (footerNewsletter) {
    var footerForm = footerNewsletter.querySelector('[data-footer-newsletter-form]');
    var footerInput = footerNewsletter.querySelector('[data-footer-newsletter-input]');
    var footerSubmit = footerNewsletter.querySelector('[data-footer-newsletter-submit]');
    var footerMessage = footerNewsletter.querySelector('[data-footer-newsletter-message]');
    var footerMailchimpAction = footerNewsletter.getAttribute('data-mailchimp-action') || '';

    function showFooterMessage(text, isError) {
      if (!footerMessage) return;
      footerMessage.textContent = text;
      footerMessage.hidden = false;
      footerMessage.classList.toggle('footer__newsletter-message--error', !!isError);
    }

    if (footerForm) {
      footerForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (footerInput && footerInput.value) ? footerInput.value.trim() : '';
        if (footerMessage) {
          footerMessage.hidden = true;
          footerMessage.textContent = '';
          footerMessage.classList.remove('footer__newsletter-message--error');
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showFooterMessage('Please enter a valid email address.', true);
          return;
        }
        if (footerSubmit) footerSubmit.disabled = true;
        subscribeViaMailchimp(footerMailchimpAction, email, {
          onSuccess: function () {
            if (footerSubmit) footerSubmit.disabled = false;
            if (footerForm) footerForm.hidden = true;
            showFooterMessage('Thanks for subscribing!', false);
          },
          onError: function (message) {
            if (footerSubmit) footerSubmit.disabled = false;
            showFooterMessage(message, true);
          }
        });
      });
    }
  }

  // ----- Email popup: show after delay, collect email via contact form, show discount code -----
  var emailPopup = document.querySelector('[data-email-popup]');
  if (emailPopup) {
    var popupStorageKey = 'apollo_email_popup_shown';
    var delaySec = parseInt(emailPopup.getAttribute('data-delay-seconds'), 10) || 10;
    var discountCode = emailPopup.getAttribute('data-discount-code') || 'Apollo10';
    var popupForm = emailPopup.querySelector('.email-popup__form') || emailPopup.querySelector('[data-email-popup-form-el]');
    var popupFormState = emailPopup.querySelector('[data-email-popup-form]');
    var popupSuccessState = emailPopup.querySelector('[data-email-popup-success]');
    var popupCodeDisplay = emailPopup.querySelector('[data-email-popup-code-display]');
    var popupError = emailPopup.querySelector('[data-email-popup-error]');
    var popupInput = emailPopup.querySelector('[data-email-popup-input]');
    var popupSubmit = emailPopup.querySelector('[data-email-popup-submit]');
    var popupCloseBtns = emailPopup.querySelectorAll('[data-email-popup-close]');

    function openEmailPopup() {
      emailPopup.classList.add('is-open');
      emailPopup.setAttribute('aria-hidden', 'false');
    }
    function closeEmailPopup() {
      emailPopup.classList.remove('is-open');
      emailPopup.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem(popupStorageKey, '1'); } catch (e) {}
    }

    popupCloseBtns.forEach(function (btn) {
      btn.addEventListener('click', closeEmailPopup);
    });
    if (emailPopup.querySelector('.email-popup__backdrop')) {
      emailPopup.querySelector('.email-popup__backdrop').addEventListener('click', closeEmailPopup);
    }

    try {
      if (sessionStorage.getItem(popupStorageKey)) return;
    } catch (e) {}
    setTimeout(openEmailPopup, delaySec * 1000);

    if (popupForm) {
      var mailchimpAction = emailPopup.getAttribute('data-mailchimp-action') || '';
      popupForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (popupInput && popupInput.value) ? popupInput.value.trim() : '';
        if (popupError) {
          popupError.hidden = true;
          popupError.textContent = '';
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (popupError) {
            popupError.textContent = 'Please enter a valid email address.';
            popupError.hidden = false;
          }
          return false;
        }
        if (!mailchimpAction || mailchimpAction.indexOf('list-manage.com/subscribe/post') === -1) {
          if (popupError) {
            popupError.textContent = 'Please add your Mailchimp form URL in Theme settings (Email popup section).';
            popupError.hidden = false;
          }
          return false;
        }
        if (popupSubmit) popupSubmit.disabled = true;
        subscribeViaMailchimp(mailchimpAction, email, {
          onSuccess: function () {
            if (popupFormState) popupFormState.hidden = true;
            if (popupSuccessState) {
              popupSuccessState.hidden = false;
              if (popupCodeDisplay) popupCodeDisplay.textContent = discountCode;
            }
            try { sessionStorage.setItem(popupStorageKey, '1'); } catch (err) {}
          },
          onError: function (message) {
            if (popupSubmit) popupSubmit.disabled = false;
            if (popupError) {
              popupError.textContent = message;
              popupError.hidden = false;
            }
          }
        });
        return false;
      });
    }
  }
});
